import React, { FC, useEffect } from 'react';
import { Grid } from '@mui/material';
import './CommentTicket.scss';
import { SCUIContent } from '../../../atomic/organisms';
import { CommentQuery } from '../../../services/query';
import { useTranslation } from 'react-i18next';
import { CommentCommand } from '../../../services/command';
import DeleteIcon from '@mui/icons-material/Delete';
import { SCUIBreadCrumb, SCUICustomDataGrid, SCUITextFieldWithButton } from '../../../atomic/molecules';
import Swal from 'sweetalert2';
import { CT } from './commentTicket.classes';
export const CommentTicket: FC<any> = () => {
    const { t } = useTranslation();
    const [tagNames, setTagNames] = React.useState([]);
    const [value, setValue] = React.useState('');
    const [refresh, setRefresh] = React.useState(false);
    useEffect(() => {
        GetCommentTicketList();
    }, [refresh]);

    const GetCommentTicketList = async (): Promise<any> => {
        try {
            let commentText: any = await CommentQuery.GetCommentTicketList();
            if (commentText.data) setTagNames(commentText.data);
        } catch (error) {
            console.log('Hata :>> ', error);
        }
    };
    const sil = async (params: any) => {
        const result = await Swal.fire({
            text: t('general.sureText') + ' ' + params.row.keyWord,
            cancelButtonText: t('general.cancel'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('general.delete'),
        });

        if (!result.isConfirmed) {
            return;
        }

        try {
            await CommentCommand.DeleteCommentTicket(params.id);
            Swal.fire(t('general.deleted'), ' ', 'success');
            setRefresh((prevRefreshing) => !prevRefreshing);
        } catch (error: any) {
            Swal.fire('', ' ', 'error');
            console.log('Hata :>> ', error);
        }
    };
    const handleOnCellClick = (params: any) => {
        if (params.field === 'actions') sil(params);
    };

    const ticketEkle = async () => {
        let params = { ticketName: value };
        if (value && value.trim().length > 0) {
            CommentCommand.PostCommentTicketAdd(params)
                .then(() => {
                    Swal.fire(t('general.added'), ' ', 'success');
                    setRefresh((prevRefreshing) => !prevRefreshing);
                })
                .catch((error: any) => {
                    Swal.fire('', ' ', 'error');
                    console.log('Hata :>> ', error);
                });
        } else {
            Swal.fire(t('general.emptyFieldControlText'), ' ', 'error');
        }
    };

    return (
        <SCUIContent className={CT.page}>
            <Grid className={CT.layout} direction="row">
                <div className={CT.breadcrumbSection}>
                    <SCUIBreadCrumb title={t('dashboard.tagManagement')} componentLink={'LcwMoney'} />
                </div>

                <div className={CT.addTicketSection}>
                    <SCUITextFieldWithButton
                        paperClassName={CT.addTicketPaper}
                        inputClassName={CT.addTicketInput}
                        buttonClassName={CT.addTicketButton}
                        buttonText={t('general.add')}
                        placeholder={t('comments.tagName')}
                        onChange={(event: any) => {
                            setValue(event.target.value);
                        }}
                        onClick={() => ticketEkle()}
                        onKeyPress={(e: any) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                ticketEkle();
                            }
                        }}
                    />
                </div>

                <div className={CT.dataGridSection}>
                    <div className={CT.dataGridWrap}>
                        <SCUICustomDataGrid
                            rows={tagNames}
                            columns={[
                                { field: 'id', headerName: 'ID', flex: 1 },
                                { field: 'keyWord', headerName: t('comments.tagName'), flex: 1 },
                                {
                                    field: 'actions',
                                    headerName: ' ',
                                    renderCell: () => {
                                        return (
                                            <span className={CT.deleteActionCell}>
                                                <DeleteIcon className={CT.deleteIcon} />
                                            </span>
                                        );
                                    },
                                },
                            ]}
                            onCellClick={handleOnCellClick}
                        />
                    </div>
                </div>
            </Grid>
        </SCUIContent>
    );
};
